<template>
  <CustomModal
    :visible="visible"
    width="500px"
    :visible_sections="{ header: false, body: true, footer: false }"
    :show_dividers="false"
    :section_classes="{ body: 'sign-in-modal-body' }"
    @update:visible="$emit('update:visible', $event)"
    @close="$emit('close')"
  >
    <div class="flex flex-col items-center gap-6">
      <div class="flex flex-col items-center gap-2 text-center">
        <h2 class="text-xl font-semibold text_color">
          Sign in or Sign up for SuperAGI
        </h2>
        <p class="text-sm secondary_color">
          SuperAGI combines 50 + AI Native apps and agents on one platform
        </p>
      </div>

      <div class="flex flex-col gap-3 w-full">
        <button
          class="oauth-btn flex items-center justify-center gap-2 w-full py-[10px] px-4 rounded-lg cursor-pointer"
          @click="goToProvider('google')"
        >
          <img
            :src="googleIcon"
            alt="google_icon"
            width="18"
            height="18"
          />
          <span class="text-sm font-medium text_color">Continue with Google work account</span>
        </button>

        <button
          class="oauth-btn flex items-center justify-center gap-2 w-full py-[10px] px-4 rounded-lg cursor-pointer"
          @click="goToProvider('microsoft')"
        >
          <img
            :src="microsoftIcon"
            alt="microsoft_icon"
            width="16"
            height="16"
          />
          <span class="text-sm font-medium text_color">Continue with Microsoft work account</span>
        </button>
      </div>

      <div class="flex items-center gap-3 w-full">
        <div class="flex-1 border-t border-separator"></div>
        <span class="text-xs secondary_color">or</span>
        <div class="flex-1 border-t border-separator"></div>
      </div>

      <a-button
        class="secondary_medium w-full"
        @click="goToAuthPage"
      >
        More Options
      </a-button>
    </div>
  </CustomModal>
</template>

<script setup>
import { appendUtmParams } from "@/src/utils/utils.js";
import CustomModal from "@/src/components/CustomModal.vue";
const googleIcon = "/images/devicon_google.svg";
const microsoftIcon = "/images/devicon_microsoft.svg";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  draftMessage: {
    type: String,
    default: "",
  },
});

defineEmits(["update:visible", "close"]);

const getAuthBaseUrl = () => {
  const host = window.location.hostname;
  if (host === "staging.superagi.com") {
    return "https://sales-staging.superagi.com";
  } else if (host === "superagi.com") {
    return "https://sales.superagi.com";
  }
  return window.location.origin;
};

const buildAuthUrl = (base) => {
  let url = appendUtmParams(base);
  if (props.draftMessage) {
    const separator = url.includes("?") ? "&" : "?";
    url += `${separator}draft_message=${encodeURIComponent(props.draftMessage)}`;
  }
  return url;
};

const goToProvider = (provider) => {
  window.location.href = buildAuthUrl(`${getAuthBaseUrl()}/auth_users?provider=${provider}`);
};

const goToAuthPage = () => {
  window.location.href = buildAuthUrl(`${getAuthBaseUrl()}/auth_users`);
};
</script>

<style scoped>
.sign-in-modal-body {
  padding: 32px 24px;
}

.oauth-btn {
  border: 1px solid var(--white-opacity-8);
  background: transparent;
  transition: background-color 0.2s ease;
}

.oauth-btn:hover {
  background: var(--white-opacity-4);
}

.border-separator {
  border-color: var(--white-opacity-8);
}
</style>
